import React from 'react'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import { Router, Route, Switch } from 'react-router-dom'
import { Provider } from 'react-redux'

import AuthLoading from './layouts/auth/loading'

import AuthLayout from './layouts/auth'
import PublicLayout from './layouts/public'
import SecureLayout from './layouts/secure'

import { PersistGate } from 'redux-persist/integration/react'

import history from './core/utils/history'
import { store, persistor } from './redux/createStore'

import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import 'react-datasheet/lib/react-datasheet.css'

import ConfigTheme from './Theme'

toast.configure()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false
      // staleTime: 5*60*1000,
    }
  }
})

const App = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <QueryClientProvider client={queryClient}>
        <ConfigTheme>
          <Router history={history}>
            <Switch>
              <Route
                path='/error'
                render={(props) => <PublicLayout {...props} />}
              />
              <Route
                path='/public'
                render={(props) => <PublicLayout {...props} />}
              />
              <Route
                path='/auth'
                render={(props) => <AuthLayout {...props} />}
              />
              <Route
                path='/secure'
                render={(props) => <SecureLayout prefix='/secure' {...props} />}
              />
              <Route
                path='/app'
                render={(props) => <SecureLayout prefix='/app' {...props} />}
              />
              <Route path='/' render={(props) => <AuthLoading {...props} />} />
            </Switch>
          </Router>
          <ReactQueryDevtools initialIsOpen={false} />
        </ConfigTheme>
      </QueryClientProvider>
    </PersistGate>
  </Provider>
)

export default App
